"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gazzola": {
    "deeaa576": [{
      "hkey": "ede9cb13",
      "slug": "canneto",
      "name": "Canneto",
      "primary": true,
      "skipSearch": false
    }],
    "canneto-sopra": [{
      "hkey": "ede9cb13",
      "slug": "canneto",
      "name": "Canneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "90244e30": [{
      "hkey": "ede9cb13",
      "slug": "canneto",
      "name": "Canneto",
      "primary": true,
      "skipSearch": false
    }],
    "canneto-sotto": [{
      "hkey": "ede9cb13",
      "slug": "canneto",
      "name": "Canneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gazzola"
    }],
    "5b9bc3da": [{
      "hkey": "00cab43f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "gazzola": [{
      "hkey": "00cab43f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4f4bf7d4": [{
      "hkey": "0d96984d",
      "slug": "gazzola",
      "name": "Gazzola",
      "primary": true,
      "skipSearch": false
    }],
    "monticello": [{
      "hkey": "0d96984d",
      "slug": "gazzola",
      "name": "Gazzola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b9b4c24": [{
      "hkey": "045c7ad5",
      "slug": "rivalta-trebbia",
      "name": "Rivalta Trebbia",
      "primary": true,
      "skipSearch": false
    }],
    "rivalta": [{
      "hkey": "045c7ad5",
      "slug": "rivalta-trebbia",
      "name": "Rivalta Trebbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;